import { Link } from 'react-router-dom';

interface FeaturedItem {
  id: number;
  title: string;
  category: string;
  rating: number;
  imageUrl: string;
}

interface FeaturedSectionProps {
  items: FeaturedItem[];
}

export default function FeaturedSection({ items }: FeaturedSectionProps) {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">为你精心挑选的优质内容</p>
        </div>
        <Link
          to="/category/dianshiju"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/article/${item.id}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-300 transition-all duration-300"
          >
            <div className="relative w-full aspect-[16/9] overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.title}
                title={`${item.title} - 国产精品在线`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2">
                <div className="flex items-center gap-1 text-accent-400 text-xs">
                  <i className="ri-star-fill"></i>
                  <span className="font-semibold">{item.rating}</span>
                </div>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                {item.category}
              </span>
              <h3 className="mt-2 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}